const config = require('configuration');
const Lime = require('lime-js');
const i18next = require('i18next');
const LocizeBackend = require('i18next-locize-backend').default;
const resourcesToBackend = require('i18next-resources-to-backend').default;
const PromiseUtil = require('toolbelt-js/src/promise-util');

const Internationalisation = Lime.Model.extend({
    start() {
        if (this.get('initPromise')) {
            return this.get('initPromise');
        }
        this.i18next = i18next;
        // noinspection JSVoidFunctionReturnValueUsed

        const initOptions = {
            lng: 'en', // if you're using a language detector, do not define the lng option
            fallbackLng: ['en'],
            fallbackNS: 'artlantic',
            debug: true,
            resources: {},
            ns: ['artlantic'],
            defaultNS: 'artlantic',
            partialBundledLanguages: true,
        };

        let Backend;
        if (config.i18n.useLocize) {
            Backend = LocizeBackend;
            Lime._.extend(initOptions, {
                backend: config.i18n.locizeOptions,
                locizeLastUsed: config.i18n.locizeOptions,
                saveMissing: config.i18n.saveMissing,
            });
        } else {
            Backend = resourcesToBackend(
                (language, namespace) => {
                    // console.debug('resourcesToBackend(language = %s, namespace = %s)', language, namespace);
                    if (namespace.indexOf('locales.') >= 0) {
                        return import(
                            /* webpackInclude: /\.json$/ */
                            `locales/lazy/${namespace.replace('locales.', '').replace(/\./g, '/')}-${language}.json`
                        );
                    }
                    return import(`locales/${namespace}-${language}.json`);
                }
            );
        }

        const promise = i18next
            .use(Backend)
            .on('failedLoading', (lng, ns, msg) => {
                Lime.handleFail({
                    message: `Loading locale failed. ns=${ns}, lng=${lng}. ${msg || ''}`
                });
            })
            .init({
                lng: 'en', // if you're using a language detector, do not define the lng option
                fallbackLng: ['en'],
                fallbackNS: 'artlantic',
                debug: true,
                resources: {},
                ns: ['artlantic'],
                defaultNS: 'artlantic',
                partialBundledLanguages: true,

                // locize
                backend: config.i18n.locizeOptions,
                locizeLastUsed: config.i18n.locizeOptions,
                saveMissing: config.i18n.saveMissing,
            });
        const promise2 = promise
            .then(Lime._.bind(this.onInited, this))
            .catch(Lime._.bind(this.onInitFails, this));
        this.set('initPromise', promise2);
        this.set('initDeferred', PromiseUtil.promiseToDfd(promise2));
        return this.get('initDeferred');
    },
    onInited() {
        Lime.Views.AbstractView.prototype.Internationalisation = this;
    },
    onInitFails(...args) {
        Lime.handleFail(...args);
    },

    /**
     * This method is called by Lime's abstract-view
     * @param el
     */
    localizeElement(el, options) {
        const opts = Lime._.extend({
            localizeChildren: true,
        }, options);
        const $el = Lime.$(el);
        let els;
        if (opts.localizeChildren) {
            els = $el.find('[data-i18n]').toArray();
        } else {
            els = [];
        }
        if ($el.attr('data-i18n')) {
            els.concat(el);
        }
        Lime._.each(els, (theEl) => {
            const $theEl = Lime.$(theEl);
            const key = $theEl.attr('data-i18n');
            const tOptions = {};
            if (options.ns) {
                tOptions.ns = options.ns;
            }
            $theEl.text(
                i18next.t(
                    key,
                    tOptions
                )
            );
        });
    },

    t(...args) {
        return this.i18next.t(...args);
    },

    setLanguage(languageCode) {
        Lime.trigger('load:show');
        this.i18next.changeLanguage(languageCode)
            .finally(() => {
                Lime.trigger('load:hide');
                // clear everything that is rendered to enforce it being rendered again via refresh route
                Lime.trigger('main:render', '');
                Lime.history.navigate(`#refresh/andThen/${Lime.history.fragment}`, { trigger: true });
            });
    },
});

const internationalisation = new Internationalisation();
window.internationalisation = internationalisation;
module.exports = internationalisation;
